/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';


export default class Zone extends Entity
{
  getSector ()
  {
    return this.parent.getSector(this.cass.sector);
  }


  getRelativeHex ()
  {
    return this.cass.id;
  }


  getAbsoluteHex ()
  {
    const sectorTransform = this.getSector().cass.transform;

    return this.getRelativeHex().transformWithObject(sectorTransform);
  }


};
